import { useHistory } from 'react-router-dom';

const useRoute = () => {
  const history = useHistory();
  const sendToLessons = (lesson, modules, course) => {
    history.push({
      pathname: '/cursos/lecciones',
      state: {
        update: true,
        lesson,
        modules,
        course,
        isComingFrom: '/cursos/detalles',
      },
    });
  };

  return {
    sendToLessons,
  };
};

export default useRoute;
